// extracted by mini-css-extract-plugin
export default {"wrapper":"Spin_wrapper__jA9Im","loading_container":"Spin_loading_container__KrTa1"};